import axios from 'axios';
import router from '../router';
import { ropeGuardManual } from './ropeGuardManual.module';

let state = {
    // motor
    motorTypeSelection: [],
    motorSizeSelection: [],
    motorPackageSelection: [],
    motorZusatzSelection: {},
    motorVoltageSelection: [],
    motorRatedSpeedSelection: [],
    certificationSelection: [],
    preferenceSelection: [],
    forcedVentilationSelection: [],
    temperatureMonitoringSelection: [],
    motorIpSelection: [],


    operatingCurrentSplus: { value: undefined, invalid: undefined },
    motordetailsSelection: [],
    tractionSheavedetailsSelection: [],
    showInputSelectionModal: false,
    showInputSelectionModal_Motor: false,
    showInputSelectionModal_TractionSheave: false,
    showRopeGuardSelectionModal: false,
    brakePartnumber: null,
    encoderPartnumber: null,

    sM250_TS280: false,

    brakeConnectionSelection: {},
    motorIP_Selection: {},

    motorManual: {},

    motorManualData: {},
    motorCablesManualData: {},
    motorSuppliesManualData: {},
    motorPackagingManualData: {},
    frameManualData: {},
    showMotorDetails: false,
    showRopeGuardDetails: false,
    continueButton_Disabled: false,
    atkonfConfigurationDifferencePartNumbers: null,

    psg: false,
    showAddOnPart: false,
}

const actions = {
    async request_offer_or_post_order_sap_storeAction({ rootState, commit, dispatch }, value) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data_manual = {


                ZLM: rootState.manualHome.configNumberZLM,
                documentType: value.type,
                motor: value.motor, //31.03.2026 Test
                frame: value.frame,
                inverter: value.inverter,
                evak: value.evak,
                recuperation: value.recuperation,
                customerID: '',
                companyCust: '',
                customerIDCust: '5054871',
                salesOrder: rootState.configurations.salesOrder,
                salesOrderPos: rootState.configurations.salesOrderPos


            }
            await axios({
                method: 'post',
                url: '/api/summaries/request_offer_or_post_order_sap',
                data: {
                    data: data_manual
                }
            })
                .then((response) => {
                    //console.log(type)
                    //console.log("HALLO")
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    if (value.type == 'A') {
                        alert("Ihre Angebotsnummer lautet: " + response.data.data.salesOrder);



                    } else if (value.type == 'U') {
                        alert("Ihre Auftragsnummer lautet: " + response.data.data.salesOrder);
                    }
                })
            //}
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

    },
    async request_Quotation_or_post_Quotation_sap_storeAction({ rootState, commit, dispatch }, value) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            const data = {


                ZLM: rootState.manualHome.configNumberZLM,
                documentType: value.type,
                motor: value.motor, //31.03.2026 Test
                frame: value.frame,
                inverter: value.inverter,
                evak: value.evak,
                recuperation: value.recuperation,
                customerID: '',
                companyCust: '',
                customerIDCust: '5054871',
                salesOrder: rootState.configurations.salesOrder,
                salesOrderPos: rootState.configurations.salesOrderPos,

            }

            await axios({
                method: 'post',
                url: '/api/summaries/request_Quotation_or_post_Quotation_sap',
                data: {
                    data: data
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    if (value.type == 'A') {
                        alert("Ihre Angebotsnummer lautet: " + response.data.data.salesOrder);


                    } else if (value.type == 'U') {
                        alert("Ihre Auftragsnummer lautet: " + response.data.data.salesOrder);
                    }

                })
            //}
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    async request_Inquiry_or_post_Inquiry_sap_storeAction({ rootState, commit, dispatch }, value) {
        try {

            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            const data = {


                ZLM: rootState.manualHome.configNumberZLM,
                documentType: value.type,
                motor: value.motor, //31.03.2026 Test
                frame: value.frame,
                inverter: value.inverter,
                evak: value.evak,
                recuperation: value.recuperation,
                customerID: '',
                companyCust: '',
                customerIDCust: '5054871',
                salesOrder: rootState.configurations.salesOrder,
                salesOrderPos: rootState.configurations.salesOrderPos,

            }

            await axios({
                method: 'post',
                url: '/api/summaries/request_Inquiry_or_post_Inquiry_sap',
                data: {
                    data: data
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    if (value.type == 'VCDM') {
                        alert("Ihre VCDM nummer wurde im Anfragebeleg angelegt. Belegnummer: " + response.data.data.salesOrder);

                    } else if (value.type == 'U') {
                        alert("Ihre Auftragsnummer lautet: " + response.data.data.salesOrder);
                    }
                })
            //}
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    async set_inputsManual_storeAction({ rootState, commit, dispatch }) {
        if (state.motorManualData != null && state.motorManualData.hasOwnProperty("details") && state.motorManualData.details.mN_MOT != null) {
            dispatch('get_allSelections_storeAction');
        }
        else {
            dispatch('get_motorSelections_storeAction');
        }
    },
    async get_allSelections_storeAction({ commit, dispatch, getters }) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            await commit('change_sM250_TS280_storeMutation', getters.motorManual_SM250_TS280);
            await dispatch('get_certificationSelection_storeAction');
            await dispatch('get_preferenceSelection_storeAction');
            await dispatch('get_temperatureMonitoringSelection_storeAction');
            await dispatch('get_motordetails_storeAction');
            await dispatch('get_motorIpSelection_argument_storeAction');
            await dispatch('get_forcedVentilationSelection_argument_storeAction');
            await this.dispatch('tractionSheaveManual/get_deliverTractionSheaveSelection_argument_storeAction');
            await this.dispatch('tractionSheaveManual/get_machiningForHandWheelSelection_argument_storeAction');
            await this.dispatch('tractionSheaveManual/get_tractionSheave_DiameterAndWidthSelection_argument_storeAction');
            await this.dispatch('tractionSheaveManual/get_tractionSheavedetails_storeAction');
            await this.dispatch('ropeGuardManual/change_ropeGuardArgument_storeAction');
            await this.dispatch('ropeGuardManual/get_customerIdKidSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_deliverRopeSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_tractionSheaveCoverSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_positionMotorSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_ropePullSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_adjustabilitySelection_storeAction');
            await this.dispatch('ropeGuardManual/get_thirdRopeGuard_storeAction');
            await this.dispatch('ropeGuardManual/get_ropeClampSelection_storeAction');
            await this.dispatch('ropeGuardManual/get_rescueReturnDeviceSelection_storeAction');
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    async get_motorSelections_storeAction({ commit, dispatch, getters }) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            await commit('change_sM250_TS280_storeMutation', getters.motorManual_SM250_TS280);
            await dispatch('get_certificationSelection_storeAction');
            await dispatch('get_preferenceSelection_storeAction');
            await dispatch('get_temperatureMonitoringSelection_storeAction');
            await dispatch('get_motordetails_storeAction');
            await dispatch('get_motorIpSelection_argument_storeAction');
            await dispatch('get_forcedVentilationSelection_argument_storeAction');
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },

    async change_partNumberMklk_storeAction({ rootState, commit, dispatch }, value) {
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            alternativePartnumberMotorKLK: value.alternativePartnumberMotorKLK,
            alternativeMKLK: value.alternativeMKLK,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/change_partNumberMklk',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('manualHome/check_toDos_at_manualHome_storeAction');

            })
            .catch(() => {
            })
            .then(() => {
            })
    },

    async get_certificationSelection_storeAction({ rootState, commit, dispatch, getters }) {
        var mLS_Law = getters.hasMotorManualData ? state.motorManualData.details.mLS_Law : getters.MLS_Law;

        const data = {
            mLS_Law: mLS_Law,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_certificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_certificationSelection_storeMutation', response.data);
                if (state.certificationSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.certificationSelection.findIndex(i => (i.text.text == getters.MLS_Law));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_certification_storeAction', state.certificationSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.certificationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_certification_storeAction', state.certificationSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_preferenceSelection_storeAction({ rootState, commit, dispatch, getters }) {
        var preference = getters.hasMotorManualData ? state.motorManualData.details.motor_preference : getters.PRAEF;

        const data = {
            preference: preference,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_preferenceSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_preferenceSelection_storeMutation', response.data);
                if (state.preferenceSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.preferenceSelection.findIndex(i => (i.text.text == getters.PRAEF));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_preference_storeAction', state.preferenceSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.preferenceSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_preference_storeAction', state.preferenceSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_temperatureMonitoringSelection_storeAction({ rootState, commit, dispatch, getters }) {

        var mLS_Law = getters.hasMotorManualData ? state.motorManualData.details.mlS_Law : getters.MLS_Law;
        var preference = getters.hasMotorManualData ? state.motorManualData.details.motor_Preference : getters.PRAEF;
        var sM250_TS280 = getters.hasMotorManualData ? getters.motorManual_SM250_TS280 : state.sM250_TS280;
        var temperatureMonitoring = getters.hasMotorManualData ? state.motorManualData.details.msart : getters.MSART;

        const data = {
            kid: rootState.manualHome.kid,
            sM250_TS280: sM250_TS280,
            mLS_Law: mLS_Law,
            preference: preference,
            temperatureMonitoring: temperatureMonitoring,
            psgMagic: false,
            psgMenu: false,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_temperatureMonitoringSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_temperatureMonitoringSelection_storeMutation', response.data);
                if (state.temperatureMonitoringSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.temperatureMonitoringSelection.findIndex(i => (i.text == getters.MSART));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_temperatureMonitoring_storeAction', state.temperatureMonitoringSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.temperatureMonitoringSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_temperatureMonitoring_storeAction', state.temperatureMonitoringSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {

            })
    },
    async get_motordetails_storeAction({ rootState, commit, dispatch, getters }) {
        var temperatureMonitoring = getters.hasMotorManualData ? state.motorManualData.details.msart : getters.MSART;
        var mLS_Law = getters.hasMotorManualData ? state.motorManualData.details.mlS_Law : getters.MLS_Law;
        var preference = getters.hasMotorManualData ? state.motorManualData.details.motor_Preference : getters.PRAEF;
        var sM250_TS280 = getters.hasMotorManualData ? getters.motorManual_SM250_TS280 : state.sM250_TS280;

        if (temperatureMonitoring != null) {
            var motorType = getters.hasMotorManualData ? state.motorManualData.details.mtyp : getters.MTYP;
            var motorSize = getters.hasMotorManualData ? state.motorManualData.details.mbg : getters.MBG;
            var motorPackage = getters.hasMotorManualData ? state.motorManualData.details.mfe : getters.MFE;
            var motorZusatz = getters.hasMotorManualData ? state.motorManualData.details.mzus : getters.MZUS;
            var motorVoltage = getters.hasMotorManualData ? state.motorManualData.details.smU1 : getters.MU1;
            var motorRatedSpeed = getters.hasMotorManualData ? state.motorManualData.details.mnr : getters.MNR;

            const data = {
                kid: rootState.manualHome.kid,
                temperatureMonitoring: temperatureMonitoring,
                mLS_Law: mLS_Law,
                preference: preference,
                sM250_TS280: sM250_TS280,
                motorType: motorType,
                motorSize: motorSize,
                motorPackage: motorPackage,
                motorZusatz: motorZusatz,
                motorVoltage: motorVoltage,
                motorRatedSpeed: motorRatedSpeed,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/get_motordetails',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    if (response.data.status.statusCode.substring(0, 1) == '2') {
                        const motordetails = response.data.data.motordetails;
                        const motorTypeSelection = motordetails.motorTypeSelection != null ? motordetails.motorTypeSelection : [];
                        const motorSizeSelection = motordetails.motorSizeSelection != null ? motordetails.motorSizeSelection : [];
                        const motorPackageSelection = motordetails.motorPackageSelection != null ? motordetails.motorPackageSelection : [];
                        const motorZusatzSelection = motordetails.motorZusatzSelection != null ? motordetails.motorZusatzSelection : [];
                        const motorVoltageSelection = motordetails.motorVoltageSelection != null ? motordetails.motorVoltageSelection : [];
                        const motorRatedSpeedSelection = motordetails.motorRatedSpeedSelection != null ? motordetails.motorRatedSpeedSelection : [];
                        commit('change_motorTypeSelection_storeMutation', motorTypeSelection);
                        commit('change_motorSizeSelection_storeMutation', motorSizeSelection);
                        commit('change_motorPackageSelection_storeMutation', motorPackageSelection);
                        commit('change_motorZusatzSelection_storeMutation', motorZusatzSelection);
                        commit('change_motorVoltageSelection_storeMutation', motorVoltageSelection);
                        commit('change_motorRatedSpeedSelection_storeMutation', motorRatedSpeedSelection);
                    }
                    else {
                    }
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },

    async get_motorIpSelection_argument_storeAction({ rootState, commit, dispatch, getters }) {
        var motorIp = null;
        if (state.motorIpSelection != null && state.motorIpSelection.length > 0) {
            const firstIndex_whichMeetConditions_motorIp = state.motorIpSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions_motorIp > -1) {
                motorIp = state.motorIpSelection[firstIndex_whichMeetConditions_motorIp].text;
            }
        }
        if (getters.hasMotorManualData) {
            motorIp = state.motorManualData.details.mip;
        }

        var temperatureMonitoring = getters.hasMotorManualData ? state.motorManualData.details.msart : getters.MSART;
        var motorType = getters.hasMotorManualData ? state.motorManualData.details.mtyp : getters.MTYP;
        var motorSize = getters.hasMotorManualData ? state.motorManualData.details.mbg : getters.MBG;
        var motorPackage = getters.hasMotorManualData ? state.motorManualData.details.mfe : getters.MFE;
        var motorZusatz = getters.hasMotorManualData ? state.motorManualData.details.mzus : getters.MZUS;
        var motorVoltage = getters.hasMotorManualData ? state.motorManualData.details.smU1 : getters.MU1;
        var motorRatedSpeed = getters.hasMotorManualData ? state.motorManualData.details.mnr : getters.MNR;

        var sM250_TS280 = getters.hasMotorManualData ? getters.motorManual_SM250_TS280 : state.sM250_TS280;

        var psg_ProdAP = (rootState.psgModal.motorSchModData != null) ? rootState.psgModal.motorSchModData.psG_ProdAP : null;

        if (motorRatedSpeed != null) {
            const data = {
                kid: rootState.manualHome.kid,
                motorType: motorType,
                motorSize: motorSize,
                motorPackage: motorPackage,
                motorZusatz: motorZusatz,
                motorVoltage: motorVoltage,
                motorRatedSpeed: motorRatedSpeed,
                temperatureMonitoring: temperatureMonitoring,
                sM250_TS280: sM250_TS280,
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                motorIp: motorIp,
                pSG_ProdAP: psg_ProdAP,
            }

            await dispatch('get_motorIpSelection_storeAction', data)
        }
    },
    async get_forcedVentilationSelection_argument_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        var motorIp = null;
        const firstIndex_whichMeetConditions_motorIp = state.motorIpSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions_motorIp > -1) {
            motorIp = state.motorIpSelection[firstIndex_whichMeetConditions_motorIp].text;
        }
        if (getters.hasMotorManualData) {
            motorIp = state.motorManualData.details.mip;
        }

        var mfbtyp = getters.hasMotorManualData ? state.motorManualData.details.mfbtyp : getters.MFBTYP;

        var temperatureMonitoring = getters.hasMotorManualData ? state.motorManualData.details.msart : getters.MSART;
        var motorType = getters.hasMotorManualData ? state.motorManualData.details.mtyp : getters.MTYP;
        var motorSize = getters.hasMotorManualData ? state.motorManualData.details.mbg : getters.MBG;
        var motorPackage = getters.hasMotorManualData ? state.motorManualData.details.mfe : getters.MFE;
        var motorZusatz = getters.hasMotorManualData ? state.motorManualData.details.mzus : getters.MZUS;
        var motorVoltage = getters.hasMotorManualData ? state.motorManualData.details.smU1 : getters.MU1;
        var motorRatedSpeed = getters.hasMotorManualData ? state.motorManualData.details.mnr : getters.MNR;

        var sM250_TS280 = getters.hasMotorManualData ? getters.motorManual_SM250_TS280 : state.sM250_TS280;

        var psg_ProdAP = (rootState.psgModal.motorSchModData != null) ? rootState.psgModal.motorSchModData.psG_ProdAP : null;

        if (motorIp != null) {
            const data = {
                kid: rootState.manualHome.kid,
                motorType: motorType,
                motorSize: motorSize,
                motorPackage: motorPackage,
                motorZusatz: motorZusatz,
                motorVoltage: motorVoltage,
                motorRatedSpeed: motorRatedSpeed,
                temperatureMonitoring: temperatureMonitoring,
                motorIp: motorIp,
                sM250_TS280: sM250_TS280,
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                mfbtyp: mfbtyp,
                pSG_ProdAP: psg_ProdAP,
            }
            await dispatch('get_forcedVentilationSelection_storeAction', data)
        }
    },
    async get_motorIpSelection_storeAction({ rootState, commit, dispatch }, value) {
        const data = {
            kid: value.kid,
            motorType: value.motorType,
            motorSize: value.motorSize,
            motorPackage: value.motorPackage,
            motorZusatz: value.motorZusatz,
            motorVoltage: value.motorVoltage,
            motorRatedSpeed: value.motorRatedSpeed,
            temperatureMonitoring: value.temperatureMonitoring,
            sM250_TS280: value.sM250_TS280,
            configurationOverviewsManualId: value.configurationOverviewsManualId,
            motorIp: value.motorIp,
            pSG_ProdAP: value.pSG_ProdAP,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_motorIpSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                dispatch('change_get_motorIpSelection_storeAction', response.data);
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_forcedVentilationSelection_storeAction({ rootState, commit, dispatch, getters }, value) {

        const data = {
            kid: value.kid,
            motorType: value.motorType,
            motorSize: value.motorSize,
            motorPackage: value.motorPackage,
            motorZusatz: value.motorZusatz,
            motorVoltage: value.motorVoltage,
            motorRatedSpeed: value.motorRatedSpeed,
            temperatureMonitoring: value.temperatureMonitoring,
            motorIp: value.motorIp,
            sM250_TS280: value.sM250_TS280,
            configurationOverviewsManualId: value.configurationOverviewsManualId,
            mfbtyp: value.mfbtyp,
            pSG_ProdAP: value.pSG_ProdAP,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_forcedVentilationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_forcedVentilationSelection_storeMutation', response.data);
                if (state.forcedVentilationSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.forcedVentilationSelection.findIndex(i => (i.text.text == getters.MFBTYP));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_forcedVentilation_storeAction', state.forcedVentilationSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.forcedVentilationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_forcedVentilation_storeAction', state.forcedVentilationSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_motordetailsSelection_storeAction({ rootState, dispatch, commit, getters }, value) {
        if (state.psg == false) {
            const motorManual = (value === 'zlw') ? getters.motordetailsSelectionZLW : getters.motordetailsSelection;
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                kid: rootState.manualHome.kid,
                motorManual: motorManual,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_motordetailsSelection',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    if (response.data != null && response.data.hasOwnProperty('motorSelection')) {
                        commit('change_motordetailsSelection_storeMutation', response.data.motorSelection);
                        if (response.data.motorSelection != null && response.data.motorSelection.length > 1 && rootState.inputsManual.motorManualData == null) {
                            dispatch('change_showInputSelectionModal_storeAction', { value: true, component: 'motor' });
                        }
                    }
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },
    async get_tractionSheavedetailsSelection_storeAction({ rootState, dispatch, commit, getters }, value) {
        if (state.psg == false) {
            const motorManual = (value.type === 'zlw') ? getters.tractionSheavedetailsSelectionZLW : getters.tractionSheavedetailsSelection;
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                kid: rootState.manualHome.kid,
                motorManual: motorManual,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_tractionSheavedetailsSelection',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    if (response.data != null && response.data.hasOwnProperty('tractionSheaveSelection')) {
                        commit('change_tractionSheavedetailsSelection_storeMutation', response.data.tractionSheaveSelection);
                        if (response.data.tractionSheaveSelection != null && response.data.tractionSheaveSelection.length > 1 && rootState.inputsManual.motorManualData == null) {
                            if (value.show == true) {
                                dispatch('change_showInputSelectionModal_storeAction', { value: true, component: 'tractionSheave' });
                            }
                        }
                    }
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },
    async get_motorManual_BrakePartNumber_storeAction({ rootState, dispatch, commit, getters }, value) {
        const motorManual = {
            mbg: state.motorManualData.details.mbg,
            mfe: state.motorManualData.details.mfe,
            brakeNominalvoltage: state.motorManualData.details.brakeNominalVoltage,
            bcspae: state.motorManualData.details.bcspae,
            bhl: state.motorManualData.details.bhl,
            bksich: state.motorManualData.details.bksich,
            motor_ForcedVentilationWithBrakeRelease: state.motorManualData.details.motor_ForcedVentilationWithBrakeRelease,
            mN_MOT: getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : (getters.motorData_mN_MOT != null ? getters.motorData_mN_MOT : null),

        }

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            kid: rootState.manualHome.kid,
            motorManual: motorManual,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_motorManual_BrakePartNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data != null && response.data.hasOwnProperty('partnumber')) {
                    commit('change_brakePartnumber_storeMutation', response.data.partnumber);
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_motorManual_EncoderPartNumber_storeAction({ rootState, dispatch, commit, getters }, value) {
        const motorManual = {
            gtyp: state.motorManualData.details.gtyp,
            mN_MOT: getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : (getters.motorData_mN_MOT != null ? getters.motorData_mN_MOT : null),
        }

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            kid: rootState.manualHome.kid,
            motorManual: motorManual,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_motorManual_EncoderPartNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data != null && response.data.hasOwnProperty('partnumber')) {
                    commit('change_encoderPartnumber_storeMutation', response.data.partnumber);
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    change_motorType_setDefaultValues_storeAction({ commit, dispatch }) {
        commit('change_motorSizeSelection_storeMutation', []);
        commit('change_motorPackageSelection_storeMutation', []);
        commit('change_motorZusatzSelection_storeMutation', {});
        commit('change_motorVoltageSelection_storeMutation', []);
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
    },
    change_motorSize_setDefaultValues_storeAction({ commit, dispatch }) {
        commit('change_motorPackageSelection_storeMutation', []);
        commit('change_motorZusatzSelection_storeMutation', {});
        commit('change_motorVoltageSelection_storeMutation', []);
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
    },
    change_motorPackage_setDefaultValues_storeAction({ commit, dispatch }, value) {
        commit('change_motorZusatzSelection_storeMutation', {});
        commit('change_motorVoltageSelection_storeMutation', []);
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
    },
    change_motorZusatz_setDefaultValues_storeAction({ commit, dispatch }, value) {
        commit('change_motorVoltageSelection_storeMutation', []);
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
    },
    change_motorVoltage_setDefaultValues_storeAction({ commit, dispatch }, value) {
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
    },
    change_motorRatedSpeed_setDefaultValues_storeAction({ commit, dispatch }, value) {
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
    },
    change_temperatureMonitoring_setDefaultValues_storeAction({ commit, dispatch }, value) {
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);
        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
    },
    async change_SM250_TS280_storeAction({ commit, dispatch }, value) {
        await commit('change_sM250_TS280_storeMutation', value);
        await dispatch('set_inputManual_Motor_toDefault2_storeAction');
        await dispatch('get_temperatureMonitoringSelection_storeAction');
        await dispatch('get_motordetails_storeAction');
        await dispatch('get_motorIpSelection_argument_storeAction');
        await dispatch('get_forcedVentilationSelection_argument_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
    },
    async change_certification_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            await commit('change_certificationSelected_storeMutation', null);
        }
        else {
            await commit('change_certificationSelected_storeMutation', value.text.text);
            const firstIndex_whichMeetConditions = state.certificationSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                if (state.motorManualData != null && state.motorManualData.details.mN_MOT != null) {
                }
                else {
                    await dispatch('get_temperatureMonitoringSelection_storeAction');
                }
            }
        }
    },
    async change_preference_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_preferenceSelected_storeMutation', null);
        }
        else {
            commit('change_preferenceSelected_storeMutation', value.text.text);
            const firstIndex_whichMeetConditions = state.preferenceSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                if (state.motorManualData != null && state.motorManualData.details.mN_MOT != null) {
                }
                else {
                    await dispatch('get_temperatureMonitoringSelection_storeAction');
                }
            }
        }
    },
    async change_temperatureMonitoring_storeAction({ commit, dispatch, rootState, getters }, value) {
        if (state.motorManualData == null && (value == null || (value.text != getters.MSART))) {
            dispatch('change_temperatureMonitoring_setDefaultValues_storeAction')
        }
        commit('change_temperatureMonitoringSelected_storeMutation', value.text);
        const firstIndex_whichMeetConditions = state.temperatureMonitoringSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            if (state.motorManualData != null && state.motorManualData.details.mN_MOT != null) {
            }
            else {
                await dispatch('get_motordetails_storeAction');
            }
        }
    },
    async change_motorType_storeAction({ commit, dispatch, getters }, value) {
        if (state.motorManualData == null && (value == null || (value.text.text != getters.MTYP))) {
            await this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
            await this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        }
        const selectedValue = value == null ? null : value.text.text;
        commit('change_motorTypeSelected_storeMutation', selectedValue);

        if (state.motorSizeSelection != null && state.motorSizeSelection.length > 0) {
            commit('change_motorSize_Disabled_storeMuation', getters.MTYP);
            await dispatch('change_motorSize_storeAction', getters.searchMotorSize);
        }
    },
    async change_motorSize_storeAction({ commit, dispatch, getters }, value) {
        if (state.motorManualData == null && (value == null || (value.text.text != getters.MBG))) {
            await this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
            await this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        }

        const selectedValue = value == null
            ? null
            : { typ: getters.MTYP, baug: value.text.text }

        commit('change_motorSizeSelected_storeMutation', selectedValue);

        if (state.motorPackageSelection != null && state.motorPackageSelection.length > 0) {
            const valueCheckDisabled = { typ: getters.MTYP, baug: getters.MBG }
            commit('change_motorPackage_Disabled_storeMuation', valueCheckDisabled);
            await dispatch('change_motorPackage_storeAction', getters.searchMotorPackage);
        }
    },
    async change_motorPackage_storeAction({ commit, dispatch, getters }, value) {
        if (state.motorManualData == null && (value == null || (value.text.text != getters.MFE))) {
            await this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
            await this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        }

        const selectedValue = value == null
            ? null
            : { typ: getters.MTYP, baug: getters.MBG, fe: value.text.text }

        commit('change_motorPackageSelected_storeMutation', selectedValue);

        if (state.motorZusatzSelection != null && state.motorZusatzSelection.length > 0) {
            const valueCheckDisabled = { typ: getters.MTYP, baug: getters.MBG, fe: getters.MFE, }
            commit('change_motorZusatz_Disabled_storeMuation', valueCheckDisabled);
            await dispatch('change_motorZusatz_storeAction', getters.searchMotorZusatz);
        }
    },
    async change_motorZusatz_storeAction({ commit, dispatch, rootState, getters }, value) {
        if (state.motorManualData == null && (value == null || (value.text.text != getters.MZUS))) {
            await this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
            await this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        }
        if (state.motorZusatzSelection != null) {
            const motorZusatzNecessary = getters.motorZusatzNecessary;

            const selectedValue = value == null
                ? null
                : { typ: getters.MTYP, baug: getters.MBG, fe: getters.MFE, zusatz: value.text.text }

            if (motorZusatzNecessary == false && selectedValue != null) {
                commit('change_motorZusatzOptionalSelected_storeMutation', selectedValue);
            }
            else {
                commit('change_motorZusatzSelected_storeMutation', selectedValue);
            }
        }

        if (state.motorVoltageSelection != null && state.motorVoltageSelection.length > 0) {
            const valueCheckDisabled = {
                typ: getters.MTYP,
                baug: getters.MBG,
                fe: getters.MFE,
                zusatz: getters.MZUS,
            }
            commit('change_motorVoltage_Disabled_storeMuation', valueCheckDisabled);
            await dispatch('change_motorVoltage_storeAction', getters.searchMotorVoltage);
        }
    },
    async change_motorVoltage_storeAction({ commit, dispatch, getters }, value) {
        const selectedValue = value == null
            ? null
            : { typ: getters.MTYP, baug: getters.MBG, fe: getters.MFE, zusatz: getters.MZUS, u1: value.value }

        commit('change_motorVoltageSelected_storeMutation', selectedValue);

        if (state.motorRatedSpeedSelection != null && state.motorRatedSpeedSelection.length > 0) {
            const valueCheckDisabled = {
                typ: getters.MTYP,
                baug: getters.MBG,
                fe: getters.MFE,
                zusatz: getters.MZUS,
                u1: getters.MU1,
            }
            commit('change_motorRatedSpeed_Disabled_storeMuation', valueCheckDisabled);
            await dispatch('change_motorRatedSpeed_storeAction', getters.searchMotorRatedSpeed);

        }
    },
    async change_motorRatedSpeedSelected_storeAction({ commit, dispatch, rootState }, value) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            await dispatch('change_motorRatedSpeed_storeAction', value);
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    async change_motorRatedSpeed_storeAction({ commit, dispatch, rootState, getters }, value) {
        const selectedValue = value == null
            ? null
            : { typ: getters.MTYP, baug: getters.MBG, fe: getters.MFE, zusatz: getters.MZUS, u1: getters.MU1, nr: value.value }

        await commit('change_motorRatedSpeedSelected_storeMutation', selectedValue);

        if (getters.motorRatedSpeed != null) {
            //if (state.motorIpSelection == null || state.motorIpSelection.length < 1) {
            if (state.motorManualData != null && state.motorManualData.details.mN_MOT != null) {
            }
            else if (rootState.psgModal.psgMenu == false) {
                await dispatch('get_motorIpSelection_argument_storeAction');
                await dispatch('get_forcedVentilationSelection_argument_storeAction');
            }
            //}
        }
    },
    async change_get_motorIpSelection_storeAction({ commit, dispatch }, value) {
        await commit('change_motorIpSelection_storeMutation', value);
    },
    async change_motorIpSelected_storeAction({ commit, dispatch, rootState, getters }, value) {

        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            if (value.selected == true) {
                await commit('change_motorIpSelected_storeMutation', 'IP21')
            }
            else {
                await commit('change_motorIpSelected_storeMutation', value.text)
            }
            if (rootState.psgModal.psgMenu == false) {
                await dispatch('get_forcedVentilationSelection_argument_storeAction');
            }
            else {
                await this.dispatch('psgModal/get_forcedVentilationSelection_argument_storeAction');
            }
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

    },
    change_forcedVentilation_storeAction({ commit, dispatch }, value) {
        commit('change_forcedVentilationSelected_storeMutation', value);
        dispatch('get_motordetailsSelection_storeAction', 'zlm');
    },

    // rope guard
    async get_suppliesSelections_storeAction({ rootState, commit, dispatch }) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            await this.dispatch('ropeGuardManual/change_ropeGuardArgument_storeAction');
            await this.dispatch('ropeGuardManual/get_modalRopeGuardOptionsSelections_storeAction');
            await this.dispatch('ropeGuardManual/get_altRopeGuardSelections_storeAction')
            await dispatch('get_motorManual_BrakePartNumber_storeAction');
            await dispatch('get_motorManual_EncoderPartNumber_storeAction');
            await dispatch('get_motorIP_Selection_storeAction');
            await dispatch('get_bowdenwireSelection_storeAction');
            await dispatch('get_brakeConnectionSelection_storeAction');
            await dispatch('get_rotatedBrakeReleaseSelection_storeAction');
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

    },
    async get_motorIP_Selection_storeAction({ rootState, commit, dispatch, getters }) {
        if (getters.hasMotorManualData) {
            const mN_MOT = getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : (getters.motorData_mN_MOT != null ? getters.motorData_mN_MOT : null);

            const data = {
                mN_MOT: mN_MOT,
                mfbtyp: state.motorManualData.details.mfbtyp,
                mip: state.motorManualData.details.mip,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/get_motorIP_Selection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_motorIP_Selection_storeMutation', response.data);
                })
                .catch(() => {
                })
                .then(() => {

                })
        }
    },

    async get_brakeConnectionSelection_storeAction({ rootState, commit, dispatch, getters }) {
        var psg_ProdAP = rootState.psgModal.motorSchModData != null ? rootState.psgModal.motorSchModData.psG_ProdAP : null;
        var psG_Controller = rootState.psgModal.motorSchModData != null ? rootState.psgModal.motorSchModData.psG_Controller : null;

        if (getters.hasMotorManualData) {
            const mip = getters.motorIp != null ? getters.motorIp : state.motorManualData.details.mip;

            const mN_MOT = getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : (getters.motorData_mN_MOT != null ? getters.motorData_mN_MOT : null);
            const data = {
                motorType: state.motorManualData.details.mtyp,
                motorSize: state.motorManualData.details.mbg,
                motorPackage: state.motorManualData.details.mfe,
                motorZusatz: state.motorManualData.details.mzus,
                motorVoltage: state.motorManualData.details.smU1,
                motorRatedSpeed: state.motorManualData.details.mnr,
                temperatureMonitoring: state.motorManualData.details.msart,
                tractionSheaveDiameter: state.motorManualData.details.td,
                tractionSheaveWidth: state.motorManualData.details.tb,
                kid: rootState.manualHome.kid,
                sM250_TS280: getters.motorManual_SM250_TS280,
                bcspae: state.motorManualData.details.bcspae,
                bcspan: state.motorManualData.details.bcspan,
                bksich: state.motorManualData.details.bksich,
                mN_MOT: mN_MOT,
                tnzbb: state.motorManualData.details.tnzbb,
                psgProdAP: psg_ProdAP,
                psG_Controller: psG_Controller,
                mfbtyp: state.motorManualData.details.mfbtyp,
                mip: mip,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_brakeConnectionSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_brakeConnectionSelection_storeMutation', response.data);
                    dispatch('checkIf_suppliesRopeGuard_areValid_storeAction');
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },
    async get_bowdenwireSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {

        var psg_ProdAP = rootState.psgModal.motorSchModData != null ? rootState.psgModal.motorSchModData.psG_ProdAP : null;
        var psG_Controller = rootState.psgModal.motorSchModData != null ? rootState.psgModal.motorSchModData.psG_Controller : null;


        if (getters.hasMotorManualData) {
            const mip = getters.motorIp != null ? getters.motorIp : state.motorManualData.details.mip;
            const tnbow = rootGetters['driveTechnologiesManual/bowdenwireDetailsSelected'].blockNumber ? rootGetters['driveTechnologiesManual/bowdenwireDetailsSelected'].blockNumber : state.motorManualData.details.tnbow;
            const lspezb = rootGetters['driveTechnologiesManual/lspezb'] != null ? rootGetters['driveTechnologiesManual/lspezb'] : state.motorManualData.details.lspezb;

            const mN_MOT = getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : (getters.motorData_mN_MOT != null ? getters.motorData_mN_MOT : null);

            const data = {
                motorType: state.motorManualData.details.mtyp,
                motorSize: state.motorManualData.details.mbg,
                motorPackage: state.motorManualData.details.mfe,
                motorZusatz: state.motorManualData.details.mzus,
                motorVoltage: state.motorManualData.details.smU1,
                motorRatedSpeed: state.motorManualData.details.mnr,
                temperatureMonitoring: state.motorManualData.details.msart,
                tractionSheaveDiameter: state.motorManualData.details.td,
                tractionSheaveWidth: state.motorManualData.details.tb,
                kid: rootState.manualHome.kid,
                sM250_TS280: getters.motorManual_SM250_TS280,
                mN_TS: state.motorManualData.details.mN_TS,
                bcspae: state.motorManualData.details.bcspae,
                bcspan: state.motorManualData.details.bcspan,
                bksich: state.motorManualData.details.bksich,
                bhl: state.motorManualData.details.bhl,
                mN_MOT: mN_MOT,
                tnbow: tnbow,
                lspezb: lspezb,
                psgProdAP: psg_ProdAP,
                psG_Controller: psG_Controller,
                mfbtyp: state.motorManualData.details.mfbtyp,
                mip: mip,
            }

            await axios({
                method: 'post',
                url: '/api/driveTechnologiesManual/get_bowdenwireSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    if (response != null && response.data != null && response.data.deliver != null) {
                        this.commit('driveTechnologiesManual/change_bowdenwireDeliverSelection_storeMutation', response.data.deliver);
                        this.commit('driveTechnologiesManual/change_bowdenwireDetailsSelection_storeMutation', response.data.details);
                    }
                    dispatch('checkIf_suppliesRopeGuard_areValid_storeAction');
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },

    async get_rotatedBrakeReleaseSelection_storeAction({ rootState, commit, dispatch, getters }) {
        var psg_ProdAP = rootState.psgModal.motorSchModData != null ? rootState.psgModal.motorSchModData.psG_ProdAP : null;
        var psG_Controller = rootState.psgModal.motorSchModData != null ? rootState.psgModal.motorSchModData.psG_Controller : null;

        if (getters.hasMotorManualData) {
            const data = {
                kid: rootState.manualHome.kid,
                psgProdAP: psg_ProdAP,
                psG_Controller: psG_Controller,
                temperatureMonitoring: state.motorManualData.details.msart,
                mN_BREM: state.motorManualData.details.mN_BREM,
                mfbtyp: state.motorManualData.details.mfbtyp,
                motorType: state.motorManualData.details.mtyp,
                motorSize: state.motorManualData.details.mbg,
                motorPackage: state.motorManualData.details.mfe,
                motorZusatz: state.motorManualData.details.mzus,
                motorVoltage: state.motorManualData.details.smU1,
                motorRatedSpeed: state.motorManualData.details.mnr,
                mLS_Law: state.motorManualData.details.mlS_Law,
                sM250_TS280: getters.motorManual_SM250_TS280,
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                llaghl: state.motorManualData.details.llaghl,
            }
            await axios({
                method: 'post',
                url: '/api/driveTechnologiesManual/get_rotatedBrakeReleaseSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    this.commit('driveTechnologiesManual/change_rotatedBrakeReleaseSelection_storeMutation', response.data);
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },
    async change_inputSelectionMotorTractionSheave_storeAction({ commit, dispatch }) {
        await dispatch('get_suppliesSelections_storeAction');
    },
    change_motorIP_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_motorIP_Selected_storeMutation', null);
        }
        else {
            commit('change_motorIP_Selected_storeMutation', value.text);
        }
        dispatch('get_motorManual_BrakePartNumber_storeAction');
        dispatch('get_motorManual_EncoderPartNumber_storeAction');
        dispatch('get_bowdenwireSelection_storeAction');
        dispatch('get_brakeConnectionSelection_storeAction');
        dispatch('get_rotatedBrakeReleaseSelection_storeAction');
    },
    async change_bowdenwireDeliver_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            await this.commit('driveTechnologiesManual/change_bowdenwireDeliverSelected_storeMutation', null);
            await this.commit('driveTechnologiesManual/change_bowdenwireDetailsSelected_storeMutation', null);
        }
        else {
            await this.commit('driveTechnologiesManual/change_bowdenwireDeliverSelected_storeMutation', value.text.text);
            if (value.text.code == null || value.text.code == 0) {
                await this.commit('driveTechnologiesManual/change_bowdenwireDetailsSelected_storeMutation', null);
            }
        }
        await dispatch('checkIf_suppliesRopeGuard_areValid_storeAction');
    },
    async change_bowdenwireDetails_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            await this.commit('driveTechnologiesManual/change_bowdenwireDetailsSelected_storeMutation', null);
        }
        else {
            await this.commit('driveTechnologiesManual/change_bowdenwireDetailsSelected_storeMutation', value.blockNumber);
        }
        await dispatch('checkIf_suppliesRopeGuard_areValid_storeAction');
    },
    async change_brakeConnection_configuration_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            await commit('change_brakeConnectionSelected_storeMutation', null);
        }
        else {
            await commit('change_brakeConnectionSelected_storeMutation', value.blockNumber);
        }
        await dispatch('checkIf_suppliesRopeGuard_areValid_storeAction');
    },
    cancelManualMotorConfiguration_storeAction() {
        router.push({ params: { slug: 'ManualHome' } });
    },

    checkIf_inputsManual_areValid_storeAction({ rootState, dispatch, commit, getters, rootGetters }) {
        var numberOf_inputs_whichAreInvalid = 0;

        if (rootGetters['ropeGuardManual/deliverRope'] == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (rootState.manualHome.kid == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MTYP == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MBG == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MFE == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MU1 == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MNR == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MLS_Law == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.PRAEF == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MSART == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.tractionSheaveManual.deliverTractionSheave == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.tractionSheaveManual.deliverTractionSheave != null && rootState.tractionSheaveManual.deliverTractionSheave != 0) {
            if (rootState.tractionSheaveManual.machiningForHandWheel == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth == null || rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth == null || rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.sheaveProfile == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.ropeDiameter == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.grooveDistance == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.numberOfGrooves == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
        }
        if (numberOf_inputs_whichAreInvalid > 0) {
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1446 }, { textKey: 1449 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            commit('change_psg_storeMutation', false)
            router.push({ params: { slug: 'driveTechnologiesManual' } });
        }
    },

    checkIf_inputsManualPsg_areValid_storeAction({ rootState, dispatch, commit, getters, rootGetters }) {
        var numberOf_inputs_whichAreInvalid = 0;
        if (rootGetters['ropeGuardManual/deliverRope'] == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (rootState.manualHome.kid == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.mtyp == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.mbg == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.mfe == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.smU1 == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.mnr == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.MFBTYP == null && state.forcedVentilationSelection != null && state.forcedVentilationSelection.length > 0) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.mlS_Law == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.preference == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.psgModal.motorDataSch.msart == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.tractionSheaveManual.deliverTractionSheave == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.tractionSheaveManual.deliverTractionSheave != null && rootState.tractionSheaveManual.deliverTractionSheave != 0) {
            if (rootState.tractionSheaveManual.machiningForHandWheel == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth == null || rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth == null || rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.sheaveProfile == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.ropeDiameter == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.grooveDistance == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            if (rootState.tractionSheaveManual.numberOfGrooves == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
        }

        if (numberOf_inputs_whichAreInvalid > 0) {
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1446 }, { textKey: 1449 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else if (rootGetters['ropeGuardManual/deliverRope'] != null && rootGetters['ropeGuardManual/deliverRope'] == 1 && (rootGetters['ropeGuardManual/positionMotor'] == null || rootGetters['ropeGuardManual/ropePull'] == null || rootGetters['ropeGuardManual/adjustability'] == null)) {
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1446 }, { textKey: 3533 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            commit('change_psg_storeMutation', true)
            router.push({ params: { slug: 'driveTechnologiesManual' } });
            this.dispatch('psgModal/set_defaultValues_storeAction');
        }
    },


    change_technicalConfigurationInformationControlTechnologies_storeAction({ rootState, commit }, value) {
        this.commit('manualHome/change_ZlwInverterSeries_storeMutation', value.inverterSeries);
        this.commit('manualHome/change_ZlwInverterType_storeMutation', value.inverterType);
        this.commit('manualHome/change_ZlwBrakeResistorType_storeMutation', value.brakeResistorType);
        this.commit('manualHome/change_ZlwRecuperationType_storeMutation', value.recuperationType);
        this.commit('manualHome/change_ZlwRadioInterferenceFilterType_storeMutation', value.radioInterferenceFilterType);
        this.commit('manualHome/change_ZlwBrakeControlType_storeMutation', value.brakeControlType);
    },

    change_technicalConfigurationInformationControlTechnologies_toDefault_storeAction({ commit }) {
        this.commit('manualHome/change_ZlwInverterSeries_storeMutation', null);
        this.commit('manualHome/change_ZlwInverterType_storeMutation', null);
        this.commit('manualHome/change_ZlwBrakeResistorType_storeMutation', null);
        this.commit('manualHome/change_ZlwRecuperationType_storeMutation', null);
        this.commit('manualHome/change_ZlwRadioInterferenceFilterType_storeMutation', null);
        this.commit('manualHome/change_ZlwBrakeControlType_storeMutation', null);
    },

    async loadAllDataMotorManual_storeAction({ commit, dispatch, rootState }) {
        if (rootState.manualHome.configurationOverviewsManualId != null) {
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            }
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            await axios({
                method: 'post',
                url: '/api/inputsManual/loadAllDataMotorManual',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    dispatch('change_loadConfiguration_storeAction', response.data);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
        }
        else {
            commit('change_motorManualData_storeMutation', null);
        }

    },

    async loadAllDataMotorManualZlw_storeAction({ commit, dispatch, rootState }) {
        const configurationOverviewsId = rootState.configurations.configurationOverviewsId;
        if (configurationOverviewsId != null || fileContent != null) {
            var kid = null;
            var firstIndex_whichMeetConditions = rootState.manualHome.customerNameOverviewSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                kid = rootState.manualHome.customerNameOverviewSelection[firstIndex_whichMeetConditions].text.text
            }

            const data = {
                configurationOverviewsId: configurationOverviewsId,
                kid: kid,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/loadAllDataMotorManualZlw',
                data: {
                    data: data,
                }

            })
                .then((response) => {
                    dispatch('change_loadConfiguration_storeAction', response.data);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('configurations/remove_configurationOverviewsId_at_sessionStorage_storeAction');
                })

            this.dispatch('FI/loadAllDataInverterManual_storeAction');
            this.dispatch('EVAC/loadAllDataEVACManual_storeAction');
            this.dispatch('ZArec/loadAllDataZArecManual_storeAction');

        }
        else {
            this.dispatch('configurations/remove_configurationOverviewsId_at_sessionStorage_storeAction');
            commit('change_motorManualData_storeMutation', null);
        }
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

    },

    async get_newVersionZlwCalculation_storeAction({ rootState, commit, dispatch }) {
        if (rootState.manualHome.configurationOverviewsManualId != null) {
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            }
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_newVersionZlwCalculation',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    dispatch('change_loadConfiguration_storeAction', response.data);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })
        }
        else {
            commit('change_motorManualData_storeMutation', null);
        }

    },

    async change_loadConfiguration_storeAction({ rootState, commit, dispatch }, value) {
        await this.dispatch('statusHandling/change_dataAndStatus_storeAction', value);
        if (value.status.statusCode.substring(0, 1) == '2') {
            if (value.data.motorData != null || value.data.frame != null) {
                await commit('change_motorManualData_storeMutation', value.data);
                await this.commit('manualHome/change_customerNameOverviewSelected_storeMutation', value.data.kid);
                await this.commit('psgModal/change_motorSchModData_storeMutation', null);
                await this.dispatch('manualHome/change_configurationOverviewsManualId_storeAction', value.data.configurationOverviewsManualId);
                await this.commit('manualHome/change_ZlwNumber_storeMutation', value.data.zlwNumber);
                await this.commit('manualHome/change_configNumberZLM_storeMuatation', value.data.zlmNumber);
                if (value.data.motorData != null && value.data.motorData.hasOwnProperty('detailsSchMod')) {
                    await this.commit('psgModal/change_motorSchModData_storeMutation', value.data.motorData.detailsSchMod);
                }
                if (value.data.hasOwnProperty('suffixSelection')) {
                    await this.commit('manualHome/change_suffixSelection_storeMutation', value.data.suffixSelection);
                }
                if (value.data.hasOwnProperty('zlwNumber')) {
                    await this.commit('manualHome/change_ZlwNumber_storeMutation', value.data.zlwNumber);
                    await dispatch('change_technicalConfigurationInformationControlTechnologies_storeAction', value.data);
                    if (rootState.manualHome.technicalConfiguration == true) {
                        if (value.data.cables == null && value.data.supplies == null && value.data.packaging == null) {
                            router.push('../manualStep/addOnPartModal');
                        }
                        else {
                            router.push('../manualStep/ManualHome');
                        }
                    }
                }

            }
            else {
                dispatch('set_loadConfiguration_toDefault_storeAction');
            }
        }
        else {
            dispatch('set_loadConfiguration_toDefault_storeAction');
        }

    },

    set_loadConfiguration_toDefault_storeAction({ commit, dispatch }) {
        commit('change_showAddOnPart_storeMutation', false);
        commit('change_motorManualData_storeMutation', null);
        this.commit('manualHome/change_ZlwNumber_storeMutation', null);
        this.commit('manualHome/change_suffixSelection_storeMutation', []);
        this.commit('psgModal/change_motorSchModData_storeMutation', null);
        dispatch('change_technicalConfigurationInformationControlTechnologies_toDefault_storeAction');
    },

    set_inputManual_toDefault_storeAction({ dispatch, commit }) {
        dispatch('set_inputManual_Motor_toDefault_storeAction');
        this.dispatch('psgModal/set_inputManual_SCHMOD_toDefault_storeAction');
        this.dispatch('tractionSheaveManual/set_inputManual_TractionSheave_toDefault_storeAction');
        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        this.commit('psgModal/change_SchModDetails_storeMuation', []);
    },

    set_inputManual_Motor_toDefault_storeAction({ commit }) {
        commit('change_motorTypeSelection_storeMutation', []);
        commit('change_motorSizeSelection_storeMutation', []);
        commit('change_motorPackageSelection_storeMutation', []);
        commit('change_motorZusatzSelection_storeMutation', {});
        commit('change_motorVoltageSelection_storeMutation', []);
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_certificationSelection_storeMutation', []);
        commit('change_preferenceSelection_storeMutation', []);
        commit('change_temperatureMonitoringSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_tractionSheavedetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);

        commit('change_operatingCurrentSplus_storeMutation', { value: null, invalid: null });

    },
    set_inputManual_Motor_toDefault2_storeAction({ commit }) {
        commit('change_motorTypeSelection_storeMutation', []);
        commit('change_motorSizeSelection_storeMutation', []);
        commit('change_motorPackageSelection_storeMutation', []);
        commit('change_motorZusatzSelection_storeMutation', {});
        commit('change_motorVoltageSelection_storeMutation', []);
        commit('change_motorRatedSpeedSelection_storeMutation', []);
        commit('change_temperatureMonitoringSelection_storeMutation', []);
        commit('change_motorIpSelection_storeMutation', []);
        commit('change_forcedVentilationSelection_storeMutation', []);
        commit('change_motordetailsSelection_storeMutation', []);
        commit('change_tractionSheavedetailsSelection_storeMutation', []);
        commit('change_brakePartnumber_storeMutation', null);
        commit('change_encoderPartnumber_storeMutation', null);

        commit('change_operatingCurrentSplus_storeMutation', { value: null, invalid: null });
    },

    checkIf_changesAt_configurationFlow_storeAction({ rootState, dispatch, commit }) {
        commit('change_motorManualData_storeMutation', null);
    },

    async get_informationAtkonf_storeAction({ rootState }) {
        if (rootState.manualHome.configurationOverviewsManualId != null) {
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/get_informationAtkonf',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    if (response.data != null) {
                        let blob = new Blob([response.data], { type: 'text/xml' });
                        let url = URL.createObjectURL(blob);
                        window.open(url);
                        URL.revokeObjectURL(url);
                    }
                    else {
                        alert('Keine Daten gefunden!');
                    }
                })
                .catch(() => {
                })
                .then(() => {
                })
        }
    },

    checkIf_suppliesRopeGuard_areValid_storeAction({ rootState, dispatch, commit }) {
        var numberOf_inputs_whichAreInvalid = 0;
        if (state.brakeConnectionSelection != null && Array.isArray(state.brakeConnectionSelection)) {
            const fristIndexWhere_Selected_brakeConnection = state.brakeConnectionSelection.findIndex(i => i.selected == true);
            if (fristIndexWhere_Selected_brakeConnection == -1 || state.brakeConnectionSelection[fristIndexWhere_Selected_brakeConnection].blockNumber == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
        }
        else {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (rootState.driveTechnologiesManual.bowdenwireDeliverSelection != null && rootState.driveTechnologiesManual.bowdenwireDeliverSelection.length > 0) {
            const firstIndexWhere_Selected_bowdenwireDeliver = rootState.driveTechnologiesManual.bowdenwireDeliverSelection.findIndex(i => i.selected == true);
            if (firstIndexWhere_Selected_bowdenwireDeliver == -1) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            else {
                if (rootState.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndexWhere_Selected_bowdenwireDeliver].showDetails === true && (rootState.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndexWhere_Selected_bowdenwireDeliver].text.code != null && rootState.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndexWhere_Selected_bowdenwireDeliver].text.code > 0)) {
                    const firstIndexWhere_Selected_bowdenwireDetails = rootState.driveTechnologiesManual.bowdenwireDetailsSelection.findIndex(i => i.selected == true);
                    if (firstIndexWhere_Selected_bowdenwireDetails == -1) {
                        numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                    }

                }
            }

        }

        if (numberOf_inputs_whichAreInvalid > 0) {
            commit('change_supplieRopeGuardContinueButton_Disabled_storeMutation', true);
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            commit('change_supplieRopeGuardContinueButton_Disabled_storeMutation', false);
        }
    },

    async checkIf_addOnParts_areValid_storeAction({ rootState, dispatch, getters, rootGetters }) {
        const deliverRope = rootGetters['ropeGuardManual/deliverRope'] != null ? rootGetters['ropeGuardManual/deliverRope'] : null;
        const tractionSheaveCover = rootGetters['ropeGuardManual/tractionSheaveCover'] != null ? rootGetters['ropeGuardManual/tractionSheaveCover'] : null;

        const mN_MOT = getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : null;
        const mN_TS = getters.tractionSheaveSelection_mN_TS != null ? getters.tractionSheaveSelection_mN_TS : null;
        if ((deliverRope == null || deliverRope == 0) && (tractionSheaveCover == null || tractionSheaveCover == 0) && (rootState.ropeGuardManual.altRopeGuard == null || ((rootState.ropeGuardManual.altLseilsSelectedCode == null || rootState.ropeGuardManual.altLseilsSelectedCode == 0) && (rootState.ropeGuardManual.altLtsabdSelectedCode == null || rootState.ropeGuardManual.altLtsabdSelectedCode == 0)))) {
            alert("Information: \n\nOhne Seilschutz \n\nWithout rope guard")
        }
        if ((deliverRope == null || deliverRope == 0) && (rootState.ropeGuardManual.altRopeGuard != null && ((rootState.ropeGuardManual.altLseilsSelectedCode != null && rootState.ropeGuardManual.altLseilsSelectedCode > 0) || (rootState.ropeGuardManual.altLtsabdSelectedCode != null && rootState.ropeGuardManual.altLtsabdSelectedCode > 0)))) {
            alert("Information: \n\nBitte wenden Sie sich bez\u00fcglich des gew\u00e4hlten Seilschutzes an den Vertrieb Support. \n\nPlease contact the Sales Support department regarding the selected rope guard.")
        }
        if (mN_MOT == null || mN_MOT == 0) {
            alert("Attention: \n\nKeine Teilenummer f\u00fcr Motor \n\nNo part number for motor")
        }
        if (mN_TS == null || mN_TS == 0) {
            alert("Attention: \n\nKeine Teilenummer f\u00fcr Treibscheibe \n\nNo part number for traction sheave")
        }
        dispatch('insertOrUpdate_suppliesRopeGuard_storeAction')
    },

    async insertOrUpdate_suppliesRopeGuard_storeAction({ rootState, dispatch, getters, rootGetters }) {
        const mN_MOT = getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : null;
        const mN_TS = getters.tractionSheaveSelection_mN_TS != null ? getters.tractionSheaveSelection_mN_TS : null;
        if (mN_MOT != null && mN_TS != null) {
            var lSEILS = rootGetters['ropeGuardManual/deliverRope'];
            var lTSABD = rootGetters['ropeGuardManual/tractionSheaveCover'];
            var lTKLEM = rootGetters['ropeGuardManual/ropeClamp'];
            var lRUEV = rootGetters['ropeGuardManual/lruev'];
            var fUESSE = null;
            var sEILAB = null;
            var eINST = rootGetters['ropeGuardManual/adjustability'];
            var altRopeGuard = false;
            if ((lSEILS == null || lSEILS == 0) &&
                (lTSABD == null || lTSABD == 0) &&
                rootState.ropeGuardManual.altRopeGuard != null && rootState.ropeGuardManual.altRopeGuard.id != null) {
                lSEILS = rootState.ropeGuardManual.altLseilsSelectedCode;
                lTSABD = rootState.ropeGuardManual.altLtsabdSelectedCode;
                lTKLEM = rootState.ropeGuardManual.altLtklemSelectedCode;
                lRUEV = rootState.ropeGuardManual.altLruevSelectedCode;
                fUESSE = rootState.ropeGuardManual.altRopeGuard.fuesse.text;
                sEILAB = rootState.ropeGuardManual.altRopeGuard.seilab.text;
                eINST = rootState.ropeGuardManual.altRopeGuard.einst.text;
                altRopeGuard = true;
            }

            const motorManual = {
                mIP: getters.motorIp,
                fUESSE: fUESSE,
                sEILAB: sEILAB,
                eINST: eINST,
                lSEILS: lSEILS,
                lTSABD: lTSABD,
                lTKLEM: lTKLEM,
                lRUEV: lRUEV,
                mN_SAS: rootGetters['ropeGuardManual/thirdRopeGuard'],
                tNZBB: getters.tnzbb,
                lSPEZB: rootGetters['driveTechnologiesManual/lspezb'],
                tnbow: rootGetters['driveTechnologiesManual/bowdenwireDetailsSelected'].blockNumber,
                sPEZBL: rootGetters['driveTechnologiesManual/bowdenwireDetailsSelected'].length,
                llaghl: rootGetters['driveTechnologiesManual/llaghl'],
                mN_MOT: mN_MOT,
                mN_TS: mN_TS,
                mN_BREM: state.brakePartnumber,
                alternativeRopeGuard: altRopeGuard,
            }
            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                motorManual: motorManual,
            }
            await axios({
                method: 'post',
                url: '/api/configurations/insertOrUpdate_suppliesRopeGuard',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    this.dispatch('manualHome/check_configurationManual_Exist_storeAction', rootState.manualHome.configurationOverviewsManualId);
                    this.dispatch('manualHome/check_configurationOverviewsManualId_storeAction');
                    router.push({ params: { slug: 'ManualHome' } })
                    //router.push({ params: { slug: 'cables' } })
                })
                .catch(() => { })
                .then(() => {
                })
        }
    },
    async change_showInputSelectionModal_storeAction({ commit }, value) {
        await commit('change_showInputSelectionModal_Motor_storeMutation', false);
        await commit('change_showInputSelectionModal_TractionSheave_storeMutation', false);
        if (value != null && value.value != false) {
            if (value.component == 'motor') {
                await commit('change_showInputSelectionModal_Motor_storeMutation', true);
                await commit('change_showInputSelectionModal_storeMutation', true);
            }
            else if (value.component == 'tractionSheave') {
                await commit('change_showInputSelectionModal_TractionSheave_storeMutation', true);
                await commit('change_showInputSelectionModal_storeMutation', true);
            }
        }
        else {
            await commit('change_showInputSelectionModal_storeMutation', false);
        }
    },

    async change_showRopeGuardSelectionModal_storeAction({ commit }, value) {
        await commit('change_showRopeGuardSelectionModal_storeMutation', value);
    },
}

const mutations = {
    change_sM250_TS280_storeMutation(state, payload) {
        state.sM250_TS280 = payload;
    },
    change_motorTypeSelection_storeMutation(state, payload) {
        state.motorTypeSelection = payload;
    },
    change_motorSizeSelection_storeMutation(state, payload) {
        state.motorSizeSelection = payload;
    },
    change_motorPackageSelection_storeMutation(state, payload) {
        state.motorPackageSelection = payload;
    },
    change_motorZusatzSelection_storeMutation(state, payload) {
        state.motorZusatzSelection = payload;
    },
    change_motorVoltageSelection_storeMutation(state, payload) {
        state.motorVoltageSelection = payload;
    },
    change_motorRatedSpeedSelection_storeMutation(state, payload) {
        state.motorRatedSpeedSelection = payload;
    },
    change_certificationSelection_storeMutation(state, payload) {
        state.certificationSelection = payload;
    },
    change_preferenceSelection_storeMutation(state, payload) {
        state.preferenceSelection = payload;
    },
    change_temperatureMonitoringSelection_storeMutation(state, payload) {
        state.temperatureMonitoringSelection = payload;
    },
    change_motorIpSelection_storeMutation(state, payload) {
        state.motorIpSelection = payload
    },
    change_forcedVentilationSelection_storeMutation(state, payload) {
        state.forcedVentilationSelection = payload;
    },
    change_motorTypeSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorTypeSelection.length; i++) {
            state.motorTypeSelection[i].selected = false;

            if (state.motorTypeSelection[i].text.text == payload) {
                state.motorTypeSelection[i].selected = true;
            }
        }
    },
    change_motorSizeSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorSizeSelection.length; i++) {
            state.motorSizeSelection[i].selected = false;
            if (payload != null && payload.hasOwnProperty('baug') && state.motorSizeSelection[i].text.text == payload.baug &&
                state.motorSizeSelection[i].disabled == false &&
                state.motorSizeSelection[i].typ == payload.typ) {
                state.motorSizeSelection[i].selected = true;
            }
        }
    },
    change_motorPackageSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorPackageSelection.length; i++) {
            state.motorPackageSelection[i].selected = false;

            if (payload != null && payload.hasOwnProperty('fe') && state.motorPackageSelection[i].text.text == payload.fe &&
                state.motorPackageSelection[i].disabled == false &&
                state.motorPackageSelection[i].typ == payload.typ &&
                state.motorPackageSelection[i].baug == payload.baug) {
                state.motorPackageSelection[i].selected = true;
            }
        }
    },
    change_motorZusatzSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorZusatzSelection.length; i++) {
            state.motorZusatzSelection[i].selected = false;

            if (payload != null && payload.hasOwnProperty('zusatz') && state.motorZusatzSelection[i].text.text == payload.zusatz &&
                state.motorZusatzSelection[i].disabled == false &&
                state.motorZusatzSelection[i].typ == payload.typ &&
                state.motorZusatzSelection[i].baug == payload.baug &&
                state.motorZusatzSelection[i].fe == payload.fe) {
                state.motorZusatzSelection[i].selected = true;
            }
        }
    },
    change_motorZusatzOptionalSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorZusatzSelection.length; i++) {
            if (payload != null && payload.hasOwnProperty('zusatz') && state.motorZusatzSelection[i].text.text == payload.zusatz &&
                state.motorZusatzSelection[i].disabled == false &&
                state.motorZusatzSelection[i].typ == payload.typ &&
                state.motorZusatzSelection[i].baug == payload.baug &&
                state.motorZusatzSelection[i].fe == payload.fe) {
                if (state.motorZusatzSelection[i].selected == true) {
                    state.motorZusatzSelection[i].selected = false;
                }
                else {
                    state.motorZusatzSelection[i].selected = true;
                }
            }
            else {
                state.motorZusatzSelection[i].selected = false;
            }
        }
    },
    change_motorVoltageSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorVoltageSelection.length; i++) {
            state.motorVoltageSelection[i].selected = false;

            if (payload != null && payload.hasOwnProperty('u1') && state.motorVoltageSelection[i].value == payload.u1 &&
                state.motorVoltageSelection[i].disabled == false &&
                state.motorVoltageSelection[i].typ == payload.typ &&
                state.motorVoltageSelection[i].baug == payload.baug &&
                state.motorVoltageSelection[i].fe == payload.fe &&
                state.motorVoltageSelection[i].zusatz == payload.zusatz) {
                state.motorVoltageSelection[i].selected = true;
            }
        }
    },
    change_motorRatedSpeedSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorRatedSpeedSelection.length; i++) {
            state.motorRatedSpeedSelection[i].selected = false;
            if (payload != null && payload.hasOwnProperty('nr') && state.motorRatedSpeedSelection[i].value == payload.nr &&
                state.motorRatedSpeedSelection[i].disabled == false &&
                state.motorRatedSpeedSelection[i].typ == payload.typ &&
                state.motorRatedSpeedSelection[i].baug == payload.baug &&
                state.motorRatedSpeedSelection[i].fe == payload.fe &&
                state.motorRatedSpeedSelection[i].zusatz == payload.zusatz &&
                state.motorRatedSpeedSelection[i].u1 == payload.u1) {
                state.motorRatedSpeedSelection[i].selected = true;
            }
        }
    },
    change_certificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.certificationSelection.length; i++) {
            state.certificationSelection[i].selected = false;

            if (state.certificationSelection[i].text.text == payload) {
                state.certificationSelection[i].selected = true;
            }
        }
    },
    change_preferenceSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.preferenceSelection.length; i++) {
            state.preferenceSelection[i].selected = false;

            if (state.preferenceSelection[i].text.text == payload) {
                state.preferenceSelection[i].selected = true;
            }
        }
    },
    change_temperatureMonitoringSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.temperatureMonitoringSelection.length; i++) {
            state.temperatureMonitoringSelection[i].selected = false;
            if (state.temperatureMonitoringSelection[i].text == payload) {
                state.temperatureMonitoringSelection[i].selected = true;
            }
        }
    },
    change_forcedVentilationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.forcedVentilationSelection.length; i++) {
            state.forcedVentilationSelection[i].selected = false;
            if (payload != null && payload != '' && state.forcedVentilationSelection[i].text.text == payload.text.text) {
                state.forcedVentilationSelection[i].selected = true;
            }
        }
    },
    change_motorIpSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorIpSelection.length; i++) {
            state.motorIpSelection[i].selected = false;

            if (state.motorIpSelection[i].text == payload) {
                state.motorIpSelection[i].selected = true;
            }
        }
    },
    change_operatingCurrentSplus_storeMutation(state, payload) {
        state.operatingCurrentSplus = payload;
    },

    change_motorSize_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.motorSizeSelection.length; i++) {
            state.motorSizeSelection[i].disabled = false;
            state.motorSizeSelection[i].selected = false;

            if (state.motorSizeSelection[i].typ != payload) {
                state.motorSizeSelection[i].disabled = true;
            }
        }
    },
    change_motorPackage_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.motorPackageSelection.length; i++) {
            state.motorPackageSelection[i].disabled = false;
            state.motorPackageSelection[i].selected = false;

            if (state.motorPackageSelection[i].typ != payload.typ ||
                state.motorPackageSelection[i].baug != payload.baug) {

                state.motorPackageSelection[i].disabled = true;
            }
        }
    },
    change_motorZusatz_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.motorZusatzSelection.length; i++) {
            state.motorZusatzSelection[i].disabled = false;
            state.motorZusatzSelection[i].selected = false;

            if (state.motorZusatzSelection[i].typ != payload.typ ||
                state.motorZusatzSelection[i].baug != payload.baug ||
                state.motorZusatzSelection[i].fe != payload.fe) {

                state.motorZusatzSelection[i].disabled = true;
            }
        }
    },
    change_motorVoltage_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.motorVoltageSelection.length; i++) {
            state.motorVoltageSelection[i].disabled = false;
            state.motorVoltageSelection[i].selected = false;

            if (state.motorVoltageSelection[i].typ != payload.typ ||
                state.motorVoltageSelection[i].baug != payload.baug ||
                state.motorVoltageSelection[i].fe != payload.fe ||
                state.motorVoltageSelection[i].zusatz != payload.zusatz) {

                state.motorVoltageSelection[i].disabled = true;
            }
        }
    },
    change_motorRatedSpeed_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.motorRatedSpeedSelection.length; i++) {
            state.motorRatedSpeedSelection[i].disabled = false;
            state.motorRatedSpeedSelection[i].selected = false;

            if (state.motorRatedSpeedSelection[i].typ != payload.typ ||
                state.motorRatedSpeedSelection[i].baug != payload.baug ||
                state.motorRatedSpeedSelection[i].fe != payload.fe ||
                state.motorRatedSpeedSelection[i].zusatz != payload.zusatz ||
                state.motorRatedSpeedSelection[i].u1 != payload.u1) {

                state.motorRatedSpeedSelection[i].disabled = true;
            }
        }
    },
    change_showInputSelectionModal_storeMutation(state, payload) {
        state.showInputSelectionModal = payload;
    },
    change_showInputSelectionModal_Motor_storeMutation(state, payload) {
        state.showInputSelectionModal_Motor = payload;
    },
    change_showInputSelectionModal_TractionSheave_storeMutation(state, payload) {
        state.showInputSelectionModal_TractionSheave = payload;
    },
    change_showRopeGuardSelectionModal_storeMutation(state, payload) {
        state.showRopeGuardSelectionModal = payload;
    },
    //
    change_motorIP_Selection_storeMutation(state, payload) {
        state.motorIP_Selection = payload;
    },
    change_motorIP_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorIP_Selection.length; i++) {
            state.motorIP_Selection[i].selected = false;
            if (payload != null && payload != '' && state.motorIP_Selection[i].text == payload) {
                state.motorIP_Selection[i].selected = true;
            }
        }
    },
    change_motordetailsSelection_storeMutation(state, payload) {
        state.motordetailsSelection = payload;
    },
    change_motordetailsSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motordetailsSelection.length; i++) {
            state.motordetailsSelection[i].selected = false;
            if (payload != null && payload != '' && state.motordetailsSelection[i].id == payload) {
                state.motordetailsSelection[i].selected = true;
            }
        }
    },
    change_tractionSheavedetailsSelection_storeMutation(state, payload) {
        state.tractionSheavedetailsSelection = payload;
    },
    change_tractionSheavedetailsSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.tractionSheavedetailsSelection.length; i++) {
            state.tractionSheavedetailsSelection[i].selected = false;
            if (payload != null && payload != '' && state.tractionSheavedetailsSelection[i].id == payload) {
                state.tractionSheavedetailsSelection[i].selected = true;
            }
        }
    },
    change_brakePartnumber_storeMutation(state, payload) {
        state.brakePartnumber = payload;
    },
    change_encoderPartnumber_storeMutation(state, payload) {
        state.encoderPartnumber = payload;
    },
    change_brakeConnectionSelection_storeMutation(state, payload) {
        state.brakeConnectionSelection = payload;
    },
    change_brakeConnectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeConnectionSelection.length; i++) {
            state.brakeConnectionSelection[i].selected = false;
            if (payload != null && payload != '' && state.brakeConnectionSelection[i].blockNumber == payload) {
                state.brakeConnectionSelection[i].selected = true;
            }
        }
    },
    change_motorManual_storeMutation(state, payload) {
        state.motorManual = payload;
    },

    change_motorManualData_storeMutation(state, payload) {
        state.motorManualData = null;
        state.motorCablesManualData = null;
        state.motorSuppliesManualData = null;
        state.motorPackagingManualData = null;
        state.frameManualData = null;

        if (payload != null && payload.hasOwnProperty('motorData')) {
            state.motorManualData = payload.motorData;
        }
        if (payload != null && payload.hasOwnProperty('cables')) {
            state.motorCablesManualData = payload.cables;
        }
        if (payload != null && payload.hasOwnProperty('supplies')) {
            state.motorSuppliesManualData = payload.supplies;
        }
        if (payload != null && payload.hasOwnProperty('packaging')) {
            state.motorPackagingManualData = payload.packaging;
        }
        if (payload != null && payload.hasOwnProperty('frame')) {
            state.frameManualData = payload.frame;
        }
    },
    change_showMotorDetails_storeMutation(state, payload) {
        state.showMotorDetails = payload;
    },

    change_atkonfConfigurationDifferencePartNumbers_storeMutation(state, payload) {
        state.atkonfConfigurationDifferencePartNumbers = payload;
    },
    change_psg_storeMutation(state, payload) {
        state.psg = payload;
    },
    change_supplieRopeGuardContinueButton_Disabled_storeMutation(state, payload) {
        state.continueButton_Disabled = payload;
    },
    change_showAddOnPart_storeMutation(state, payload) {
        state.showAddOnPart = payload;
    },
}

const getters = {
    motordetailsSelection: (state, getters, rootState, rootGetters) => {
        return {
            mTYP: getters.MTYP,
            mBG: getters.MBG,
            mFE: getters.MFE,
            mZUS: getters.MZUS,
            smU1: getters.MU1,
            mNR: getters.MNR,
            mLS_Law: getters.MLS_Law,
            motor_Preference: getters.PRAEF,
            mSART: getters.MSART,
            mIP: getters.mip,
            motor_ForcedVentilationWithBrakeRelease: getters.forcedVentilationWithBrakeRelease,
            mFBTYP: getters.MFBTYP,
            tNFB: getters.tnfb,
            sM250_TS280: state.sM250_TS280,
            mN_MOT: getters.motorData_mN_MOT,
        }
    },
    motordetailsSelectionZLW: (state, getters, rootState, rootGetters) => {
        return {
            mTYP: getters.hasMotorManualData ? state.motorManualData.details.mtyp : null,
            mBG: getters.hasMotorManualData ? state.motorManualData.details.mbg : null,
            mFE: getters.hasMotorManualData ? state.motorManualData.details.mfe : null,
            mZUS: getters.hasMotorManualData ? state.motorManualData.details.mzus : null,
            smU1: getters.hasMotorManualData ? state.motorManualData.details.smU1 : null,
            mNR: getters.hasMotorManualData ? state.motorManualData.details.mnr : null,
            mLS_Law: getters.hasMotorManualData ? state.motorManualData.details.mlS_Law : null,
            motor_Preference: getters.hasMotorManualData ? state.motorManualData.details.motor_Preference : null,
            mSART: getters.hasMotorManualData ? state.motorManualData.details.msart : null,
            mIP: getters.hasMotorManualData ? state.motorManualData.details.mip : null,
            motor_ForcedVentilationWithBrakeRelease: getters.hasMotorManualData ? state.motorManualData.details.motor_ForcedVentilationWithBrakeRelease : null,
            mFBTYP: getters.hasMotorManualData ? state.motorManualData.details.mfbtyp : null,
            tNFB: getters.hasMotorManualData ? state.motorManualData.details.tnfb : null,
            sM250_TS280: getters.hasMotorManualData ? getters.motorManual_SM250_TS280 : null,
            mN_MOT: getters.hasMotorManualData ? state.motorManualData.details.mN_MOT : null,
        }
    },
    tractionSheavedetailsSelection: (state, getters, rootState, rootGetters) => {
        const mN_MOT = getters.motorSelection_mN_MOT != null ? getters.motorSelection_mN_MOT : (getters.motorData_mN_MOT != null ? getters.motorData_mN_MOT : null);
        const diameter = ((rootState.tractionSheaveManual.deliverTractionSheave == null || rootState.tractionSheaveManual.deliverTractionSheave == 0)
            && (rootGetters['ropeGuardManual/deliverRope'] == null || rootGetters['ropeGuardManual/deliverRope'] == 0))
            ? null
            : (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter : null);
        const width = ((rootState.tractionSheaveManual.deliverTractionSheave == null || rootState.tractionSheaveManual.deliverTractionSheave == 0)
            && (rootGetters['ropeGuardManual/deliverRope'] == null || rootGetters['ropeGuardManual/deliverRope'] == 0))
            ? null
            : (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width : null);

        return {
            lTR: rootState.tractionSheaveManual.deliverTractionSheave,
            lTHD: rootState.tractionSheaveManual.machiningForHandWheel,
            tD: diameter,
            tB: width,
            tARILL: rootState.tractionSheaveManual.sheaveProfile,
            tAUWI: rootState.tractionSheaveManual.undercutAngle,
            tAKWI: rootState.tractionSheaveManual.vgrooveAngle,
            tCSD: rootState.tractionSheaveManual.ropeDiameter,
            tDRA: rootState.tractionSheaveManual.grooveDistance,
            tDRZ: rootState.tractionSheaveManual.numberOfGrooves,
            mN_MOT: mN_MOT,
            mN_TS: getters.motorData_mN_TS,
        }
    },
    tractionSheavedetailsSelectionZLW: (state, getters, rootState, rootGetters) => {
        return {
            lTR: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.ltr : null,
            lTHD: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.lthd : null,
            tD: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.td : null,
            tB: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.tb : null,
            tARILL: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.tarill : null,
            tAUWI: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.tauwi : null,
            tAKWI: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.takwi : null,
            tCSD: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.tcsd : null,
            tDRA: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.tdra : null,
            tDRZ: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.tdrz : null,
            mN_MOT: getters.motorData_mN_MOT,
            mN_TS: getters.motorData_mN_TS,
        }
    },
    ropeGuardSelectionZLW: (state, getters, rootState, rootGetters) => {
        return {
            kidsch: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.kidsch : null,
            lseils: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.lseils : null,
            ltsabd: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.ltsabd : null,
            fuesse: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.fuesse : null,
            seilab: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.seilab : null,
            einst: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.einst : null,
            mN_SAS: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.mN_SAS : null,
            ltklem: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.ltklem : null,
            lruev: state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.lruev : null,
        }
    },
    hasMotorManualData: (state, getters, rootState, rootGetters) => {
        return state.motorManualData != null && state.motorManualData.hasOwnProperty('details') && state.motorManualData.details.mN_MOT != null;
    },

    inputData: (state, getters, rootState, rootGetters) => {

        const diameter = ((rootState.tractionSheaveManual.deliverTractionSheave == null || rootState.tractionSheaveManual.deliverTractionSheave == 0)
            && (rootGetters['ropeGuardManual/deliverRope'] == null || rootGetters['ropeGuardManual/deliverRope'] == 0))
            ? null
            : (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter : null);
        const width = ((rootState.tractionSheaveManual.deliverTractionSheave == null || rootState.tractionSheaveManual.deliverTractionSheave == 0)
            && (rootGetters['ropeGuardManual/deliverRope'] == null || rootGetters['ropeGuardManual/deliverRope'] == 0))
            ? null
            : (rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width : null);

        return {
            mTYP: getters.MTYP,
            mBG: getters.MBG,
            mFE: getters.MFE,
            mZUS: getters.MZUS,
            mU1: getters.MU1,
            mNR: getters.MNR,
            mLS_Law: getters.MLS_Law,
            motor_Preference: getters.PRAEF,
            mSART: getters.MSART,
            mIP: getters.mip,
            motor_ForcedVentilationWithBrakeRelease: getters.forcedVentilationWithBrakeRelease,
            mFBTYP: getters.MFBTYP,
            tNFB: getters.tnfb,
            lTR: rootState.tractionSheaveManual.deliverTractionSheave,
            lTHD: rootState.tractionSheaveManual.machiningForHandWheel,
            tD: diameter,
            tB: width,
            tARILL: rootState.tractionSheaveManual.sheaveProfile,
            tAUWI: rootState.tractionSheaveManual.undercutAngle,
            tAKWI: rootState.tractionSheaveManual.vgrooveAngle,
            tCSD: rootState.tractionSheaveManual.ropeDiameter,
            tDRA: rootState.tractionSheaveManual.grooveDistance,
            tDRZ: rootState.tractionSheaveManual.numberOfGrooves,
            kIDSCH: rootGetters['ropeGuardManual/customerIdKid'],
            fUESSE: rootGetters['ropeGuardManual/positionMotor'],
            sEILAB: rootGetters['ropeGuardManual/ropePull'],
            eINST: rootGetters['ropeGuardManual/adjustability'],
            lSEILS: rootGetters['ropeGuardManual/deliverRope'],
            lTSABD: rootGetters['ropeGuardManual/tractionSheaveCover'],
            lTKLEM: rootGetters['ropeGuardManual/ropeClamp'],
            lRUEV: rootGetters['ropeGuardManual/lruev'],
            mN_SAS: rootGetters['ropeGuardManual/thirdRopeGuard'],
            lTHD: rootState.tractionSheaveManual.machiningForHandWheel,
            sM250_TS280: state.sM250_TS280,
            pSG_Handradanbau: null,
            pSG_Handlueftung: null,
            pSG_Kabellaenge: null,
            pSG_KabellaengeBremse: null,
            pSG_Reglerart: null,
            pSG_NAM: null,
            pSG_Rillenform: null,
            psg_Produktionsort: null,
            psg_Zertifizierung: null,
            psg_ProdAP: null,
            psg_Voltage: null,
            psg_GlobalID_BG: null,
            psg_MotorID: null,
            psg_Rillenabstand: null,
            psg_No_of_rope_Grooves: null,
            psg_MIb1: null,
            psg_MBG: null,
            psg_MFE: null,
            psg_ID: null,
            psg_MNR: null,
            psG_Controller: null,
            psG_OrderStatusMotorCable: null,
            psG_OrderStatusEncoderCable: null,
            psG_OrderStatusMotorProtectionCable: null,
            psG_OrderStatusBrakeCable: null,
            psG_OrderStatusBrakeMonitoringCable: null,
            psG_OrderStatusForcedVentilationCable: null,
        }
    },

    motorSelection_mN_MOT: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motordetailsSelected = selected(state.motordetailsSelection);
        return motordetailsSelected != null ? motordetailsSelected.id : null;
    },
    motorData_mN_MOT: (state, getters, rootState, rootGetters) => {
        return state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.mN_MOT : null;
    },
    tractionSheaveSelection_mN_TS: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const tractionSheavedetailsSelected = selected(state.tractionSheavedetailsSelection);
        return tractionSheavedetailsSelected != null ? tractionSheavedetailsSelected.id : null;
    },
    motorData_mN_TS: (state, getters, rootState, rootGetters) => {
        return state.motorManualData != null && state.motorManualData.details != null ? state.motorManualData.details.mN_TS : null;
    },
    motorIp: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorIp = selected(state.motorIP_Selection);
        return motorIp != null ? motorIp.text : null;
    },
    mip: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorIp = selected(state.motorIpSelection);
        return motorIp != null ? motorIp.text : null;
    },
    forcedVentilationWithBrakeRelease: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const forcedVentilationWithBrakeRelease = selected(state.forcedVentilationSelection);
        return forcedVentilationWithBrakeRelease != null && forcedVentilationWithBrakeRelease.canBeCombinedWithBrakeRelease != null ? forcedVentilationWithBrakeRelease.canBeCombinedWithBrakeRelease.text : null;
    },
    tnfb: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const tnfbSelected = selected(state.forcedVentilationSelection);
        return tnfbSelected != null ? tnfbSelected.tnfb : null;
    },
    tnzbb: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const tNZBB = selected(state.brakeConnectionSelection);
        return tNZBB != null ? tNZBB.blockNumber : null;
    },

    motorManual_SM250_TS280: (state, getters, rootState, rootGetters) => {
        return (getters.hasMotorManualData && state.motorManualData.details.sM250_TS280 != null) ? state.motorManualData.details.sM250_TS280 : false;
    },
    motorType: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorType = selected(state.motorTypeSelection);
        return motorType;
    },
    MTYP: (state, getters, rootState, rootGetters) => {
        const motorType = getters.motorType
        return motorType != null && motorType.hasOwnProperty('text') ? motorType.text.text : null;
    },
    searchMotorSize: (state, getters, rootState, rootGetters) => {
        if (state.motorSizeSelection == null || state.motorSizeSelection.length == 0 || !Array.isArray(state.motorSizeSelection) || getters.MTYP == null) {
            return null;
        }
        const element = state.motorSizeSelection.find(i => (i.text.text == getters.MBG && i.disabled == false && i.typ == getters.MTYP));
        if (element != undefined) {
            return element;
        }
        return null;
    },
    motorSize: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorSize = selected(state.motorSizeSelection);
        return motorSize;
    },
    MBG: (state, getters, rootState, rootGetters) => {
        const motorSize = getters.motorSize
        return motorSize != null && motorSize.hasOwnProperty('text') ? motorSize.text.text : null;
    },
    searchMotorPackage: (state, getters, rootState, rootGetters) => {
        if (state.motorPackageSelection == null || state.motorPackageSelection.length == 0 || !Array.isArray(state.motorPackageSelection)) {
            return null;
        }

        const enabledMotorPackages = state.motorPackageSelection.filter(i => (i.disabled == false));
        let motorPackage = null;

        if (getters.MTYP != null && getters.MBG != null) {

            motorPackage = state.motorPackageSelection.find(i => (
                i.text.text == getters.MFE
                && i.disabled == false
                && i.typ == getters.MTYP
                && i.baug == getters.MBG
            )) || null;
        }
        if (motorPackage == null && enabledMotorPackages.length == 1) {
            motorPackage = enabledMotorPackages[0];
        }

        return motorPackage;
    },
    motorPackage: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorPackage = selected(state.motorPackageSelection);
        return motorPackage;
    },
    MFE: (state, getters, rootState, rootGetters) => {
        const motorPackage = getters.motorPackage
        return motorPackage != null && motorPackage.hasOwnProperty('text') ? motorPackage.text.text : null;
    },
    searchMotorZusatz: (state, getters, rootState, rootGetters) => {
        if (state.motorZusatzSelection == null || state.motorZusatzSelection.length == 0 || !Array.isArray(state.motorZusatzSelection)) {
            return null;
        }

        const enabledMotorZusatz = state.motorZusatzSelection.filter(i => (i.disabled == false));
        let motorZusatz = null;

        if (getters.MTYP != null && getters.MBG != null && getters.MFE != null) {

            motorZusatz = state.motorZusatzSelection.find(i => (
                i.text.text == getters.MZUS
                && i.disabled == false
                && i.typ == getters.MTYP
                && i.baug == getters.MBG
                && i.fe == getters.MFE
            )) || null;
        }
        if (motorZusatz == null && enabledMotorZusatz.length == 1) {
            motorZusatz = enabledMotorZusatz[0];
        }
        return motorZusatz;
    },
    motorZusatzNecessary: (state, getters, rootState, rootGetters) => {
        var motorZusatzNecessary = false;
        if (!Array.isArray(state.motorZusatzSelection)) {
            return false;
        }
        const motorZusatzSelection = state.motorZusatzSelection.filter((x) => !x.disabled);

        return motorZusatzSelection.length > 0
            && motorZusatzSelection.every(x => x.text.text != null);
    },
    motorZusatz: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorZusatz = selected(state.motorZusatzSelection);
        return motorZusatz;
    },
    MZUS: (state, getters, rootState, rootGetters) => {
        const motorZusatz = getters.motorZusatz
        return motorZusatz != null && motorZusatz.hasOwnProperty('text') ? motorZusatz.text.text : null;
    },
    searchMotorVoltage: (state, getters, rootState, rootGetters) => {

        if (state.motorVoltageSelection == null || state.motorVoltageSelection.length == 0 || !Array.isArray(state.motorVoltageSelection)) {
            return null;
        }

        const enabledMotorVoltage = state.motorVoltageSelection.filter(i => (i.disabled == false));
        let motorVoltage = null;

        motorVoltage = state.motorVoltageSelection.find(i => (
            i.value == getters.MU1
            && i.disabled == false
            && i.typ == getters.MTYP
            && i.baug == getters.MBG
            && i.fe == getters.MFE
            && i.zusatz == getters.MZUS
        )) || null;
        if (motorVoltage == null && enabledMotorVoltage.length == 1) {
            motorVoltage = enabledMotorVoltage[0];
        }

        return motorVoltage;
    },
    motorVoltage: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorVoltage = selected(state.motorVoltageSelection);
        return motorVoltage;
    },
    MU1: (state, getters, rootState, rootGetters) => {
        const motorVoltage = getters.motorVoltage
        return motorVoltage != null && motorVoltage.hasOwnProperty('value') ? motorVoltage.value : null;
    },
    searchMotorRatedSpeed: (state, getters, rootState, rootGetters) => {
        if (state.motorRatedSpeedSelection == null || state.motorRatedSpeedSelection.length == 0 || !Array.isArray(state.motorRatedSpeedSelection)) {
            return null;
        }

        const enabledMotorRatedSpeed = state.motorRatedSpeedSelection.filter(i => (i.disabled == false));
        let motorRatedSpeed = null;

        if (getters.MTYP != null && getters.MBG != null && getters.MFE != null) {

            motorRatedSpeed = state.motorRatedSpeedSelection.find(i => (
                i.value == getters.MNR
                && i.disabled == false
                && i.typ == getters.MTYP
                && i.baug == getters.MBG
                && i.fe == getters.MFE
                && i.zusatz == getters.MZUS
                && i.u1 == getters.MU1
            )) || null;
        }
        if (motorRatedSpeed == null && enabledMotorRatedSpeed.length == 1) {
            motorRatedSpeed = enabledMotorRatedSpeed[0];
        }
        return motorRatedSpeed;
    },
    motorRatedSpeed: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const motorRatedSpeed = selected(state.motorRatedSpeedSelection);
        return motorRatedSpeed;
    },
    MNR: (state, getters, rootState, rootGetters) => {
        const motorRatedSpeed = getters.motorRatedSpeed
        return motorRatedSpeed != null && motorRatedSpeed.hasOwnProperty('value') ? motorRatedSpeed.value : null;
    },
    certification: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const certification = selected(state.certificationSelection);
        return certification;
    },
    MLS_Law: (state, getters, rootState, rootGetters) => {
        const certification = getters.certification
        return certification != null && certification.hasOwnProperty('text') ? certification.text.text : null;
    },
    preference: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const preference = selected(state.preferenceSelection);
        return preference;
    },
    PRAEF: (state, getters, rootState, rootGetters) => {
        const preference = getters.preference
        return preference != null && preference.hasOwnProperty('text') ? preference.text.text : null;
    },
    forcedVentilation: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const forcedVentilation = selected(state.forcedVentilationSelection);
        return forcedVentilation;
    },
    MFBTYP: (state, getters, rootState, rootGetters) => {
        const forcedVentilation = getters.forcedVentilation
        return forcedVentilation != null
            ? forcedVentilation.hasOwnProperty('text')
                ? forcedVentilation.text.text
                : forcedVentilation
            : null;
    },

    temperatureMonitoring: (state, getters, rootState, rootGetters) => {
        const selected = (arr) => arr && arr.find ? (arr.find(i => i && i.selected === true) || null) : null;
        const temperatureMonitoring = selected(state.temperatureMonitoringSelection);
        return temperatureMonitoring;
    },
    MSART: (state, getters, rootState, rootGetters) => {
        const temperatureMonitoring = getters.temperatureMonitoring
        return temperatureMonitoring != null && temperatureMonitoring.hasOwnProperty('text') ? temperatureMonitoring.text : null;
    },
    motorImagePath: (state, getters, rootState, rootGetters) => {
        if (getters.motorZusatz != null && getters.motorZusatz.imagePath != null) {
            return getters.motorZusatz.imagePath
        }
        if (getters.motorPackage != null && getters.motorPackage.imagePath != null) {
            return getters.motorPackage.imagePath
        }
        if (getters.motorSize != null && getters.motorSize.imagePath != null) {
            return getters.motorSize.imagePath
        }
        if (getters.motorType != null && getters.motorType.imagePath != null) {
            return getters.motorType.imagePath
        }
        return null
    },
}

export const inputsManual = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations,
    getters
}